export const DISCOUNT_TYPE_CUSTOMER_LOYALTY = 3;
